import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityCard } from '../components/ui/Cards';
import { activities } from '../data';
import './ListPage.css';

export default function Activities() {
  const [type, setType] = useState('all');
  const [sort, setSort] = useState('popular');
  const { t } = useTranslation();

  const types = [
    { key: 'all', label: t('activities.all') },
    { key: 'adventure', label: t('activities.adventure') },
    { key: 'animal', label: t('activities.animal') },
    { key: 'cultural', label: t('activities.cultural') },
    { key: 'wellness', label: t('activities.wellness') },
  ];

  const filtered = useMemo(() => {
    let result = type === 'all' ? activities : activities.filter(a => a.type === type);
    if (sort === 'price-asc') result = [...result].sort((a, b) => a.price - b.price);
    if (sort === 'price-desc') result = [...result].sort((a, b) => b.price - a.price);
    if (sort === 'rating') result = [...result].sort((a, b) => b.rating - a.rating);
    return result;
  }, [type, sort]);

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">{t('activities.tag')}</div>
          <h1>{t('activities.title')}</h1>
          <p>12 unique activities from camel rides to hot air balloons</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container">
          <div className="list-controls">
            <div className="list-tabs">
              {types.map(tp => (
                <button
                  key={tp.key}
                  className={`list-tab${type === tp.key ? ' active' : ''}`}
                  onClick={() => setType(tp.key)}
                >{tp.label}</button>
              ))}
            </div>
            <div className="list-sort">
              <label>{t('tours.sortBy')}</label>
              <select value={sort} onChange={e => setSort(e.target.value)}>
                <option value="popular">{t('tours.popular')}</option>
                <option value="price-asc">{t('tours.priceLow')}</option>
                <option value="price-desc">{t('tours.priceHigh')}</option>
                <option value="rating">{t('tours.topRated')}</option>
              </select>
            </div>
          </div>
          <p className="list-count">{filtered.length} {t('activities.found')}</p>
          <div className="grid-4">
            {filtered.map(a => <ActivityCard key={a.id} activity={a} />)}
          </div>
        </div>
      </section>
    </>
  );
}
